export default __webpack_public_path__ + "static/media/oil3x.34e4ad31.png";